import { useState } from 'react'
import emailjs from 'emailjs-com'







export const Contact = (props) => {

  return (
<footer style={{
    textAlign: "center",
    padding: "20px 10px",
    marginTop: "40px",
    width: "100%",
    borderTop: "10px solid #eaeaea"
}}>
    <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "15px" // רווח בין התמונה לטקסט
    }}>
        
        {/* הוספת התמונה מתיקיית public */}
        <a href="https://siteb2b.co.il" target="_blank" rel="noopener noreferrer">
            <img 
                src="/logooo1.png"  // אם התמונה בתוך public/logo.png
                alt="Logo siteb2b" 
                style={{
                    maxWidth: "250px", // מגביל את רוחב התמונה
                    height: "auto",    // שומר על פרופורציות
                    display: "block"
                }} 
            />
        </a>

        <p style={{
            margin: 0,
            fontSize: "clamp(14px, 4vw, 16px)",
            color: "#333"
        }}>
            &copy; {new Date().getFullYear()} SG1 | אתר זה נבנה על ידי{' '}
            <a 
                href="https://siteb2b.co.il" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ color: "#0070f3", textDecoration: "none", fontWeight: "600" }}
            >
                siteb2b.co.il
            </a>
        </p>
    </div>
</footer>

 
  
  )
}


